import { on, send, getConfiguration, configure } from '@rlx/feim'
import {
  REQUEST_BALANCE_UPDATE, SET_SETTINGSSCREEN, SETTINGSCREENS, TOGGLE_MUTE,
  SET_QUICKSPIN, SET_EXTERNAL_ERROR_HANDLING, SHOW_MESSAGE
} from '../../redux/constants'
import { errorClosed, setExternalPause } from '../../redux/actions'
import { STOP_AUTOPLAY } from '../../components/autoplay/constants'

let lastError = null

module.exports = {
  init(store) {
    let operatorHandlesErrors
    
    configure({
      clientConfig: config.apiResponse,
      handleRgPostMessageAPI: true
    })

    on.initialized(() => {
      operatorHandlesErrors = getConfiguration().operatorHandlesErrors

      if (operatorHandlesErrors) {
        store.dispatch({ type: SET_EXTERNAL_ERROR_HANDLING, externalErrorHandling: true })

        on.errorMessageDismissed(() => {
          if (!lastError) { return }

          store.dispatch({ type: SHOW_MESSAGE })

          store.dispatch(errorClosed(lastError))

          lastError = null
        })
      }
    })

    const lastState = {}
    store.subscribe(() => {
      const { session: { visibleBalance }, base: { messages = []} } = store.getState()

      if (visibleBalance !== lastState.visibleBalance) {
        lastState.visibleBalance = visibleBalance
        send.balanceUpdate(visibleBalance)
      }

      if (operatorHandlesErrors && messages.length && messages[0].errorCode && messages[0] !== lastError) {
        lastError = messages[0]

        send.errorMessage(lastError)
      }
    })

    on.refreshBalance(() => store.dispatch({ type: REQUEST_BALANCE_UPDATE }))

    const toggleSettingsScreen = (screen) => (action) => {
      const { base: { settingScreen } } = store.getState()

      const isToggle = !action || !action.type || action.type === "toggle"
      const doShow = isToggle ? settingScreen !== screen : action.type === "show"

      if (doShow) {
        store.dispatch({ type: SET_SETTINGSSCREEN, screen })
      } else {
        store.dispatch({ type: SET_SETTINGSSCREEN, screen: null })
      }
    }

    on.togglePaytable(toggleSettingsScreen(SETTINGSCREENS.INFO))

    on.toggleGameHelp(toggleSettingsScreen(SETTINGSCREENS.RULES))

    on.freeze(() => store.dispatch(setExternalPause(true)))

    on.unfreeze(() => store.dispatch(setExternalPause(false)))

    on.updateSettings((payload) => {
      if (payload.sounds !== undefined) {
        store.dispatch({ type: TOGGLE_MUTE, muted: !payload.sounds, external: true })
      }
      if (payload.fastPlay !== undefined) {
        store.dispatch({ type: SET_QUICKSPIN, quickSpin: payload.fastPlay, external: true })
      }
    })

    on.pauseAutoPlay(() => {
      store.dispatch({ type: STOP_AUTOPLAY })
    })
  }
}
